// @core/api/endpoints/workflow/trigger_webhook.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TriggerWebhookRequest,
  TriggerWebhookResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Trigger pipeline by webhook
 * Runs the pipeline bound to this webhook token. The request must be signed with the pipeline's webhook secret; unsigned requests are refused.
 * @public This endpoint does not require authentication
 */
export async function TriggerWebhook(
  webhook_token: string,
  data: TriggerWebhookRequest,
  options?: RequestOptions
): Promise<TriggerWebhookResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/webhooks/:webhook_token`;
  requestPath = requestPath.replace(':webhook_token', encodeURIComponent(webhook_token));
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TriggerWebhookResponse>(requestPath, data, requestOptions);
}
